module.exports = __webpack_public_path__ + "img/14.51abfb05.png";